import { render, staticRenderFns } from "./menuNav.vue?vue&type=template&id=226c2488&scoped=true&"
import script from "./menuNav.vue?vue&type=script&lang=ts&"
export * from "./menuNav.vue?vue&type=script&lang=ts&"
import style0 from "./menuNav.vue?vue&type=style&index=0&id=226c2488&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226c2488",
  null
  
)

export default component.exports